import Chart from 'chart.js/auto';

// Global dark theme defaults for Chart.js
Chart.defaults.color = '#bbcabf';
Chart.defaults.font.family = "'Hanken Grotesk', sans-serif";
Chart.defaults.font.size = 12;

Chart.defaults.plugins.tooltip.backgroundColor = 'rgba(18, 33, 49, 0.95)';
Chart.defaults.plugins.tooltip.borderColor = 'rgba(187, 202, 191, 0.2)';
Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.padding = 12;
Chart.defaults.plugins.tooltip.cornerRadius = 8;
Chart.defaults.plugins.tooltip.titleColor = '#d4e4fa';
Chart.defaults.plugins.tooltip.bodyColor = '#4edea3';
Chart.defaults.plugins.tooltip.titleFont = { weight: '600', size: 13 };
Chart.defaults.plugins.tooltip.bodyFont = { weight: '500', size: 13 };

export function createSparklineChart(ctx, labels, data) {
  return new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets: [{
        data,
        borderColor: '#4edea3',
        borderWidth: 2.5,
        backgroundColor: (context) => {
          const bg = context.chart.ctx.createLinearGradient(0, 0, 0, 180);
          bg.addColorStop(0, 'rgba(78, 222, 163, 0.35)');
          bg.addColorStop(1, 'rgba(78, 222, 163, 0)');
          return bg;
        },
        fill: true,
        tension: 0.38,
        pointRadius: 3,
        pointBackgroundColor: '#4edea3',
        pointHoverRadius: 6,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: '#bbcabf', font: { size: 10 } }
        },
        y: {
          grid: { color: 'rgba(187, 202, 191, 0.08)' },
          ticks: {
            color: '#bbcabf',
            font: { size: 10 },
            callback: (val) => `R$ ${val}`
          }
        }
      }
    }
  });
}

export function createDonutChart(ctx, labels, data, colors) {
  return new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels,
      datasets: [{
        data,
        backgroundColor: colors,
        borderWidth: 2,
        borderColor: '#051424',
        hoverOffset: 6
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            padding: 14,
            usePointStyle: true,
            pointStyle: 'circle',
            color: '#bbcabf',
            font: { size: 11 }
          }
        },
        tooltip: {
          callbacks: {
            label: (ctx) => ` ${ctx.label}: R$ ${ctx.raw.toFixed(2).replace('.', ',')}`
          }
        }
      },
      cutout: '72%'
    }
  });
}

export function createBarChart(ctx, labels, data, title = '') {
  return new Chart(ctx, {
    type: 'bar',
    data: {
      labels,
      datasets: [{
        label: title,
        data,
        backgroundColor: 'rgba(78, 222, 163, 0.8)',
        borderColor: '#4edea3',
        borderWidth: 1,
        borderRadius: 6,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: '#bbcabf', font: { size: 10 } }
        },
        y: {
          grid: { color: 'rgba(187, 202, 191, 0.08)' },
          ticks: {
            color: '#bbcabf',
            font: { size: 10 },
            callback: (val) => `R$ ${val}`
          }
        }
      }
    }
  });
}
